import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
export const gpmsyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录民生银行APP->顶部搜索【交易流水下载】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      {
        msg: "时间选择近一年的时间，交易类型【全部】用途【对账】，填入专属邮箱【提交】",
      },
      { imgs: [png3, png4, png5] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      {
        msg: "交易类型【全部】用途选择【对账】打开【展示证件号码及地址】【展示交易对手信息】无需填写【高级筛选】",
      },
    ],
  },
];
